import React from 'react';
import { View, Text } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { makeStyles, useAppTheme } from '../theme/ThemeContext';

interface EmptyStateProps {
  message: string;
  /** MaterialCommunityIcons name. */
  icon?: string;
  hint?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ message, icon = 'text-box-search-outline', hint, action }: EmptyStateProps) {
  const styles = useStyles();
  const { colors } = useAppTheme();
  return (
    <View style={styles.container}>
      <View style={styles.iconWrap}>
        <MaterialCommunityIcons
          name={icon as React.ComponentProps<typeof MaterialCommunityIcons>['name']}
          size={30}
          color={colors.textPrimary}
        />
      </View>
      <Text style={styles.text}>{message}</Text>
      {hint ? <Text style={styles.hint}>{hint}</Text> : null}
      {action ? <View style={styles.action}>{action}</View> : null}
    </View>
  );
}

const useStyles = makeStyles((c) => ({
  container: { flex: 1, alignItems: 'center', justifyContent: 'center', paddingVertical: 56, paddingHorizontal: 24 },
  iconWrap: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: c.surfaceAlt,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  text: { fontSize: 17, fontWeight: '700', color: c.textPrimary, textAlign: 'center' },
  hint: { fontSize: 14, color: c.textSecondary, textAlign: 'center', marginTop: 6, maxWidth: 360 },
  action: { marginTop: 20 },
}));
